import { Link, useLocation, useNavigate } from "react-router-dom";
import { Phone, ShieldCheck, ArrowUp, MapPin, Mail } from "lucide-react";
import { Wordmark } from "@/components/Navbar";

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === "/";

  const goToSection = (id) => {
    if (!isHome) {
      navigate("/");
      setTimeout(() => window.__lenis?.scrollTo(id, { offset: -80 }), 500);
    } else {
      window.__lenis?.scrollTo(id, { offset: -80 });
    }
  };

  const goHome = () => {
    if (!isHome) {
      navigate("/");
    } else {
      window.__lenis?.scrollTo(0);
    }
  };

  const footerLinkCls =
    "text-left text-xs uppercase tracking-[0.2em] text-white/60 transition-colors hover:text-copper";

  return (
    <footer className="relative overflow-hidden bg-[#102630] text-white" data-testid="site-footer">
      <div className="blueprint-grid absolute inset-0" aria-hidden="true" />
      <div className="relative mx-auto grid max-w-7xl grid-cols-1 gap-12 px-5 py-16 md:grid-cols-3 md:px-10 md:py-20">
        <div>
          <Wordmark light />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/60">
            Albany's local electrician — licensed work, done properly, for 15+ years
            across the Great Southern.
          </p>
        </div>
        <nav className="flex flex-col gap-3" aria-label="Footer">
          <button data-testid="footer-home-link" onClick={goHome} className={footerLinkCls}>Home</button>
          <button data-testid="footer-services-link" onClick={() => goToSection("#services")} className={footerLinkCls}>Services</button>
          <button data-testid="footer-work-link" onClick={() => goToSection("#work")} className={footerLinkCls}>Work</button>
          <button data-testid="footer-about-link" onClick={() => goToSection("#about")} className={footerLinkCls}>About</button>
          <button data-testid="footer-contact-link" onClick={() => goToSection("#contact")} className={footerLinkCls}>Contact</button>
          <Link to="/quote" data-testid="footer-quote-link" className={footerLinkCls}>Quote</Link>
        </nav>
        <div className="flex flex-col gap-4 text-sm">
          <a
            href="tel:0490425408"
            data-testid="footer-phone-link"
            className="flex items-center gap-3 text-white transition-colors hover:text-copper"
          >
            <Phone className="h-4 w-4 text-copper" strokeWidth={1.5} />
            0490 425 408 — Derek
          </a>
          <a
            href="mailto:exchange.electrical@gmail.com"
            data-testid="footer-email-link"
            className="flex items-center gap-3 text-white transition-colors hover:text-copper"
          >
            <Mail className="h-4 w-4 shrink-0 text-copper" strokeWidth={1.5} />
            <span className="break-all">exchange.electrical@gmail.com</span>
          </a>
          <p className="flex items-center gap-3 text-white/60">
            <MapPin className="h-4 w-4 text-copper" strokeWidth={1.5} />
            Albany WA — Great Southern
          </p>
          <p className="flex items-center gap-3 text-white/60">
            <ShieldCheck className="h-4 w-4 text-copper" strokeWidth={1.5} />
            Licensed · Fully insured
          </p>
        </div>
      </div>
      <div className="relative border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-4 px-5 py-6 md:px-10">
          <p className="text-[11px] uppercase tracking-[0.25em] text-white/40">
            © 2026 Exchange Electrical · Albany WA
          </p>
          <a
            href="https://www.layerly.com.au"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-layerly-link"
            className="text-[11px] uppercase tracking-[0.25em] text-white/40 transition-colors hover:text-copper"
          >
            Made by Layerly
          </a>
          <button
            data-testid="footer-back-to-top"
            onClick={() => window.__lenis?.scrollTo(0)}
            className="flex items-center gap-2 text-[11px] uppercase tracking-[0.25em] text-white/40 transition-colors hover:text-copper"
          >
            Back to top
            <ArrowUp className="h-3.5 w-3.5" strokeWidth={1.75} />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
